import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import tokenService from './service/token.service.js';
import SessionService from './service/session.js';

const root = ReactDOM.createRoot(document.getElementById('root'));

if (!tokenService.getUser()) {
    SessionService.authenticate();
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
